export default "__VITE_ASSET__Bli3W3O6__"